import { Component } from '@angular/core';
/**
 * CustomerSupportComponent
 */
@Component({
  selector: 'ecp-customer-support',
  templateUrl: './customer-support.component.html',
  styleUrls: ['./customer-support.component.scss'],
  standalone: false,
})
export class CustomerSupportComponent {}
